module.exports = __webpack_public_path__ + "static/media/panther-bnb.ae11a0c8.png";